import { render, staticRenderFns } from "./personnelPositioning.vue?vue&type=template&id=96589688&scoped=true"
import script from "./personnelPositioning.vue?vue&type=script&lang=js"
export * from "./personnelPositioning.vue?vue&type=script&lang=js"
import style0 from "./personnelPositioning.vue?vue&type=style&index=0&id=96589688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96589688",
  null
  
)

export default component.exports